<template>
  <el-dialog
    title="交易信息"
    :visible.sync="isShow"
    width="1000px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-row class="cur-commodity">
      <el-col :span="3">
        <img :src="detailData.varietyUrl">
      </el-col>
      <el-col :span="17">
        <div>
          <span class="name">
            {{ detailData.attrList.find(attr=>attr.attrCode==='brand') ? detailData.attrList.find(attr=>attr.attrCode==='brand').v : '' }}
            {{ detailData.varietyName }}
          </span>
          <span
            v-for="attr in detailData.attrList.filter(attr=>attr.attrCode!=='brand')"
            :key="attr.attrCode"
            class="p-l-10"
          >
            {{ attr.v }}
            <span class="p-l-5">/</span>
          </span>
          <span class="p-l-10">{{ detailData.quantity }}{{ detailData.unitName }}</span>
        </div>
        <div class="m-t-15">
        <span class="p-r-20">
          {{ detailData.storeName }}
        </span>
      </div>
      <div class="m-t-15">
        <div>
        提货：
        <span >
          {{ detailData.pickupPosition }}
        </span>
        <span class="p-l-20">{{ detailData.pickupType | keyFilter('myStore','pickupType') }}</span>

        </div>
      </div>
        <div class="m-t-15">
          <span>{{ dayjs(detailData.createDate).format('YYYY-MM-DD') }}</span>
          <span
            class="p-l-10 orange"
          >
            <span class="f20">{{ detailData.unitPrice | thousandMark }}</span>
            元/吨
          </span>
        </div>
      </el-col>
      <el-col
        :span="4"
        class="right-content"
      >
        <div>
          <!-- <span class="tag f12">{{ detailData.validType | keyFilter('myStore','validType') }}</span> -->
          <span class="tag m-l-10 green f12">库存充足</span>
        </div>
      </el-col>
    </el-row>
    <el-form
      class="trade-form"
      label-width="110px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="购买数量">
            {{ detailData.quantity }}
          </el-form-item>
          <el-form-item label="提货人">
            {{ detailData.pickUpUserName }}
          </el-form-item>
          <el-form-item
            label="单价"
            required
          >
            <div v-if="optType!=='edit'">
              {{ detailData.unitPrice | thousandMark }}
            </div>
            <el-input-number
              v-else
              v-model.trim="create.unitPrice"
              class="w220"
              :controls="false"
            />
          </el-form-item>
          <el-form-item
            label="发货仓库"
            required
          >
            <div v-if="optType!=='edit'">
              {{ detailData.pickupWarehouseName }}
            </div>
            <el-select
              v-else
              v-model="create.pickupWarehouseId"
              placeholder="请选择"
              @change="selectWarehouseChange"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.warehouseName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="结算方式"
            required
          >
            {{ detailData.clearingForm | keyFilter('myStore', 'clearingForm') }}
          </el-form-item>
          <el-form-item
            label="提货人手机号"
            required
          >
            {{ detailData.pickUpPhone }}
          </el-form-item>
          <el-form-item
            label="总金额"
            required
          >
            {{ Number(create.unitPrice)*Number(detailData.quantity) | thousandMark }}
          </el-form-item>
          <el-form-item
            label="交货地点"
            required
          >
            {{ create.pickupPosition }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      v-if="optType!=='detail'"
      class="text-c"
    >
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确 认
      </el-button>
      <el-button
        type="primary"
        @click="toSubmit('refuse')"
      >
        拒 绝
      </el-button>
      <el-button
        @click="handleClose"
      >
        取 消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
import dayjs from 'dayjs'

function Create () {
  return {
    id: '', // 摘牌（意向单）记录ID
    unitPrice: '', // 单价
    pickupWarehouseId: '', // 提货仓库id
    pickupWarehouseName: '', // 提货联系人名称
    pickupPosition: '', // 提货地
    action: '', // 操作类型（必填） 1接受 2拒绝 3 编辑
    version: '', // 当前意向单版本号（必填）
  }
}
export default {
  name: 'Trade',
  components: {
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => { return {} }
    },
    optType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dayjs,
      create: new Create(),
      warehouseList: [],
      contactList: []
    }
  },
  created () {
    this.optType !== 'confirm' && this.getWarehouseList()
    this.create.unitPrice = this.detailData.unitPrice
    this.create.pickupWarehouseId = this.detailData.pickupWarehouseId
    this.create.pickupPosition = this.detailData.pickupPosition
    this.create.pickupWarehouseName = this.detailData.pickupWarehouseName
  },
  methods: {
    toSubmit (action) {
      if (Number(this.create.unitPrice) <= 0) {
        this.$message.warning('单价必须大于0')
        return
      }
      this.create.id = this.detailData.id
      this.create.version = this.detailData.version
      // 1接受  2拒绝 编辑的时候为接受
      if (action === 'refuse') {
        this.create.action = '2'
      } else {
        const actionConfig = {
          'edit': '1',
          'confirm': '1',
        }
        this.create.action = actionConfig[this.optType]
      }
      api.myStore.confirmOrUpdateOrder(this.create).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
        this.$emit('refresh')
      })
    },
    getWarehouseList () {
      api.myStore.getWarehouseData({ currentNo: '1', pageSize: '999999' }).then(res => {
        this.warehouseList = res.data.rows || []
      })
    },
    selectWarehouseChange (val) {
      const curWarehouse = this.warehouseList.find(item => item.id === val)
      this.create.pickupWarehouseName = curWarehouse.warehouseName
      this.create.pickupPosition = curWarehouse.address
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>

.cur-commodity {
  border-top: 1px solid #f8bd47;
  border-bottom: 1px solid #eaeaea;
  padding: 32px 0;
  img {
    width: 56px;
  }

  .tag {
    color: #959595;
    border-radius: 4px;
    padding: 2px 4px;
    border: 1px solid #959595;
  }
  .green {
    color:#20b37e;
    border: 1px solid #20b37e;
  }
  .black {
    color: #333333;
  }
  .orange {
    color: #ff6d00;
  }

  .right-content {
    text-align: right;
  }
  .btn {
    margin-top: 50px;
  }
  .name {
    color: #333333;
    font-size: 16px;
  }
}
.trade-form {
  margin-top: 32px;
  margin-left: 88px;
}
</style>
